import ManaParticle from "../../../ManaParticle"
import SimpleManaNode, { SimpleManaNodeOptions } from "../../SimpleManaNode"

export type EventNodeOptions = {} & SimpleManaNodeOptions

export default class EventNode extends SimpleManaNode {

	bindToEvent(particle: ManaParticle): any {
		return undefined
	}

	async act(particle: ManaParticle) {

		const observable$ = this.bindToEvent(particle)

		if (observable$) {

			let subscription = undefined as any

			await new Promise((resolve, reject) => {
				subscription = observable$.subscribe(resolve)
			})

			subscription.unsubscribe()

			return true

		}

		return false
	}

}